import React from 'react';
import { BdsIcon } from '@/core/constants/webComponents';
import { CustomTooltip } from '../CustomTooltip/CustomTooltip';
import './CustomButtonGroup.scss';

export type ButtonGroupItem = {
  id: string;
  icon: string;
  tooltipText?: string;
};

export interface CustomButtonGroupProps {
  options: ButtonGroupItem[];
  selectedItems: Set<string>;
  onToggle: (id: string) => void;
  disabled?: boolean;
}

export const CustomButtonGroup: React.FC<CustomButtonGroupProps> = ({
  options,
  selectedItems,
  onToggle,
  disabled = false,
}) => {
  return (
    <div className="custom-button-group">
      {options.map((option) => {
        const isActive = selectedItems.has(option.id);
        const itemClassName = `custom-button-group__item ${
          isActive ? 'custom-button-group__item--active' : ''
        }`;
        const ariaLabel = option.id.replaceAll('-', ' ').replaceAll(/\b\w/g, (l) => l.toUpperCase());

        if (!option.tooltipText) {
          return (
            <button
              key={option.id}
              type="button"
              aria-label={ariaLabel}
              aria-pressed={isActive}
              className={itemClassName}
              onClick={() => onToggle(option.id)}
              disabled={disabled}
            >
              <BdsIcon name={option.icon} size="small" />
            </button>
          );
        }

        return (
          <CustomTooltip key={option.id} content={option.tooltipText} position="top">
            <button
              type="button"
              aria-label={option.tooltipText}
              aria-pressed={isActive}
              className={itemClassName}
              onClick={() => onToggle(option.id)}
              disabled={disabled}
            >
              <BdsIcon name={option.icon} size="small" />
            </button>
          </CustomTooltip>
        );
      })}
    </div>
  );
};